import React from "react";

export default function HowItWorksPage() {
  const steps = [
    { n: "01", t: "Search & Compare", d: "Filter thousands of verified trainers by county, gym, price, speciality and goal." },
    { n: "02", t: "Book Instantly", d: "Pick a slot from your trainer's live calendar and pay securely online." },
    { n: "03", t: "Train & Transform", d: "Attend your session and leave a verified review to help the community." },
  ];
  return (
    <div className="container-fl py-16">
      <div className="overline mb-2">How it works</div>
      <h1 className="text-4xl sm:text-5xl font-black tracking-tighter mb-4">Simple. Verified. Effective.</h1>
      <p className="text-neutral-600 max-w-2xl mb-12">FitLink Ireland is designed to remove every friction between you and the coach that changes your life.</p>
      <div className="grid md:grid-cols-3 gap-6">
        {steps.map((s) => (
          <div key={s.n} className="card-fl p-8">
            <div className="text-5xl font-black text-emerald-600 mb-4">{s.n}</div>
            <h3 className="text-xl font-bold mb-2">{s.t}</h3>
            <p className="text-neutral-600">{s.d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
